<template>
  <AppHeaderDropdown right no-caret>
    <template slot="header">
      <img :src="userLogo" class="img-avatar" alt="user-logo" />
      {{ user.userName ? user.userName : "Admin" }}
    </template>
    <template slot="signin">
      <img src="img/avatars/6.jpg" class="img-avatar" alt="support@nipige.com" />Sign in
    </template>
    <template slot="dropdown">
      <!-- <b-dropdown-item>
        <i class="fa fa-bell-o" /> Updates
      </b-dropdown-item> -->
      <b-dropdown-item @click="$router.push({ path: '/messages' })">
        <i class="fa fa-envelope-o" /> Messages
      </b-dropdown-item>
      <b-dropdown-item
        v-if="$userRole == 'Partner'"
        @click="$router.push({ path: '/myaccount' })"
      >
        <i class="fa fa-user" />My Account
      </b-dropdown-item>
      <!-- <b-dropdown-item
        v-if="$userRole == 'Tenant'"
        @click="$router.push({ path: '/profile/profile-info' })"
      >
        <i class="fa fa-user" />Manage Profile
      </b-dropdown-item> -->
      <b-dropdown-item
        v-if="$userRole == 'Tenant'"
        @click="$router.push({ path: '/profile/profile-info' })"
      >
        <i class="fa fa-user" />Manage Profile
      </b-dropdown-item>
      <b-dropdown-item @click="logout"> <i class="fa fa-lock" /> Logout </b-dropdown-item>
    </template>
  </AppHeaderDropdown>
</template>

<script>
import { HeaderDropdown as AppHeaderDropdown } from "@/components";
import { baseState } from "@/utils/baseState";
export default {
  name: "DefaultHeaderDropdownAccnt",
  components: {
    AppHeaderDropdown,
  },
  data: () => {
    return {
      _id: null,
      user: {},
      role: null,
      userLogo: JSON.parse(sessionStorage.userLogin)["userLogo"],
    };
  },
  methods: {
    logout() {
      this.$store.replaceState(baseState);
      window.sessionStorage.removeItem("nipige-state");
      sessionStorage.clear();
      this.$store.dispatch("auth/loginUser", { _id: null });
      this.$store.dispatch("catalog/resetCatalogState");
      location.href = "/";
      this.$toasted.info("you have been logged out");
    },
  },
  mounted() {
    this.role = this.$store.getters["auth/getUserRole"];
    const user = this.$store.getters["auth/getUserID"];
    this.user = this.$store.getters["auth/getloginUser"];
  },
};
</script>
